import { useState, useEffect } from 'react';

export const fetchEnvVar = async (keyName, accessToken) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_BASE_ENDPOINT}config`, {
      method: 'POST',
      mode: 'cors', 
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ key: keyName })
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data.value;
  } catch (error) {
    console.error('Error fetching environment variable');
    throw new Error("Failed to fetch environment variable");
  }
};

export const useEnvVar = (keyName, accessToken) => {
  const [value, setValue] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getEnvVar = async () => {
      try {
        const result = await fetchEnvVar(keyName, accessToken);
        setValue(result);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    if (accessToken) {
      getEnvVar();
    }
  }, [keyName, accessToken]);

  return { value, loading, error };
};